<template>
  <div class="home">
    <FirstSection />
    <Section2 />
    <Section8 data-aos="fade-in" />
    <Section9 data-aos="fade-in" />
    <Section3 data-aos="fade-in" />
    <Section4 data-aos="fade-in" />
    <Section6 data-aos="fade-in" />
    <Section7 data-aos="fade-in" />
  </div>
</template>

<script>
export default {
  name: "Home",
  data () {
    return {};
  },
  methods: {},
  components: {
    FirstSection: () => import("./components/FirstSection.vue"),
    Section2: () => import("./components/Section2/Section2.vue"),
    Section3: () => import("./components/Section3.vue"),
    Section4: () => import("./components/Section4.vue"),
    Section6: () => import("./components/Section6.vue"),
    Section7: () => import("./components/Section7/Section7.vue"),
    Section8: () => import("./components/Section8.vue"),
    Section9: () => import("./components/Section9.vue")
  }
};
</script>

<style lang="less" scoped>
.home {
  min-height: 800px;
}
</style>
